import BoundaryError from 'common/components/BoundaryError'
import { fetchInstances } from 'supervision/instances/InstancesSlice'
import NavBar from 'common/components/NavBar'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useLocation } from 'react-router'
import { fetchCommercialFeatures } from 'gdl/commercial/commercialFeature/CommercialFeaturesSlice'

const RecettesApp = () => {
    const { pathname } = useLocation()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchInstances())
        dispatch(fetchCommercialFeatures())
    }, [dispatch])

    const links = [
        { icon: 'receipt_long', tooltip: 'Recette', url: '/recette/dashboard' },
        { icon: 'api', tooltip: 'Recette IAEAU', url: '/recette/iaeau' },
        { icon: 'view_timeline', tooltip: 'Versions', url: '/recette/versions' },
    ]
    return (
        <>
            <NavBar links={links} />
            <BoundaryError url={pathname}>
                <div style={{ marginLeft: '65px' }}>
                    <Outlet />
                </div>
            </BoundaryError>
        </>
    )
}

export default RecettesApp